import React from 'react';
import { SpinnerGap } from '@phosphor-icons/react';
import { PortfolioManager } from '../Portfolio';

export default function PortfolioTab({ loadingPortfolio, portfolioItems, fetchPortfolio }) {
  return (
    <div className="bg-white rounded-xl shadow-md p-6" data-testid="portfolio-tab">
      {loadingPortfolio ? (
        <div className="text-center py-12">
          <SpinnerGap size={40} weight="bold" className="text-[#2B4C6F] animate-spin mx-auto mb-4" />
          <p className="text-gray-500">Loading portfolio...</p>
        </div>
      ) : (
        <PortfolioManager items={portfolioItems} onRefresh={fetchPortfolio} />
      )}
    </div>
  );
}
